// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"88f2ca23","701":"6ff94c21"}[chunkId] + ".chunk.js";
};